"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const styled_1 = require("./styled");
const relativePosition_1 = __importDefault(require("../../utils/relativePosition"));
exports.Popup = (0, react_1.forwardRef)((_a, ref) => {
    var { onClose, relatedRef, relatedParent, observe, children, alignH = "center", alignV = "top", style = {} } = _a, props = __rest(_a, ["onClose", "relatedRef", "relatedParent", "observe", "children", "alignH", "alignV", "style"]);
    const [related, setRelated] = (0, react_1.useState)();
    const [stylePosition, setStylePostion] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const escapeListener = onClose &&
            (function () {
                function listener(e) {
                    if (e.key !== "Escape")
                        return;
                    e.stopImmediatePropagation();
                    onClose();
                }
                window.addEventListener("keydown", listener);
                // console.log('on')
                return function removeListener() {
                    // console.log('off');
                    window.removeEventListener("keydown", listener);
                };
            })();
        setRelated(relatedRef.current);
        return () => {
            escapeListener && escapeListener();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (!related)
            return;
        const dom = related;
        const resizeObserver = new ResizeObserver((entries) => {
            const { top, width, height, left } = (0, relativePosition_1.default)(dom, alignH, alignV, relatedParent);
            const style = {
                top: `${top}px`,
                left: `${left}px`,
            };
            observe === "width" && Object.assign(style, { width: `${width}px` });
            observe === "height" && Object.assign(style, { height: `${height}px` });
            setStylePostion(style);
        });
        resizeObserver.observe(dom);
        return () => {
            resizeObserver.unobserve(dom);
        };
    }, [related]);
    if (!related)
        return null;
    return (0, react_dom_1.createPortal)(react_1.default.createElement(styled_1.StyledPopup, Object.assign({ alignH: alignH, alignV: alignV, style: Object.assign(Object.assign({}, stylePosition), style), ref: ref }, props), children), relatedParent ? related : document.body);
});
//# sourceMappingURL=main.js.map